import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { RemarksComponent } from 'src/app/admin/menus/events/remarks/remarks.component';
import { EmailModalComponent } from '../email-modal/email-modal/email-modal.component';
@Component({
  selector: 'app-pre-incubator-list',
  templateUrl: './pre-incubator-list.component.html',
  styleUrls: ['./pre-incubator-list.component.css'],
})
export class PreIncubatorListComponent implements OnInit {
  @ViewChild('input') inputElement: ElementRef<HTMLInputElement>;
  displayedColumns: string[] = [
    'index',
    'incubatorName',
    'profileRegistered',
    'time',
    'reason',
  ];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  private listApi = environment.url + environment.preincubaterList;
  formValue: FormGroup;
  /**
   * Constructor for the PreIncubatorListComponent.
   * Initializes the component with the necessary services, form, and data source.
   * @param router The angular router service.
   * @param fb The angular form builder service.
   * @param makeapi The API service provider.
   * @param getdata The Value service provider.
   * @param dialog The Material dialog service provider.
   */
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    public dialog: MatDialog
  ) {
    /**
     * Initialize the MatTableDataSource with empty data.
     */
    this.dataSource = new MatTableDataSource();
    /**
     * Create the form group with the required fields.
     */
    this.formValue = this.fb.group({
      type: ['0'], // Default value set to '0' for "All"
    });
  }

  roleValue;
  searchVal;
  preincubationStatus;
  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   * Sets up initial visibility, retrieves role and status from session storage,
   * and initializes the form and list of pre-incubators.
   */
  ngOnInit(): void {
    // Trigger the loading indicator
    this.getdata.isVisibleSource.next(true);

    // Retrieve the user's role from session storage
    this.roleValue = sessionStorage.getItem('role');

    // Initialize the search value
    this.searchVal = this.searchValue;

    // Retrieve the pre-incubation status from session storage
    this.preincubationStatus = sessionStorage.getItem('preIncubationStatus');

    // If a pre-incubation status is present, set it in the form and as the selected option
    if (this.preincubationStatus != null) {
      this.formValue.get('type')?.setValue(this.preincubationStatus);
      this.selectedOption = this.preincubationStatus;
    }

    // Fetch the list of pre-incubators
    this.preIncubatorList();
  }
  searchValue: string;
  /**
   * Applies a search filter to the list of incubators and fetches the filtered list.
   * Updates the searchValue and calls the ListApi function to fetch the filtered list.
   * @param event The input event containing the search value.
   */
  applySearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchValue = filterValue;

    // Set the request object with the current search parameters and pagination.
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      searchString: this.searchValue,
      status: this.preincubationStatus ? this.preincubationStatus : '0',
    };

    // Call the ListApi function to fetch the filtered list of incubators from the API.
    this.ListApi();
  }
  list = {};
  disList: any = [];
  pageTotalCount: number;
  pageSize: number = 25;
  pageNumber: number = 1;
  noData = true;
  /**
   * Fetches the list of incubators and populates the table with the data.
   * Subscribes to the API response and updates the component data.
   */
  preIncubatorList() {
    // Set the request object with the current search parameters and pagination.
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      incubatorName: this.searchValue,
      status: this.preincubationStatus ? this.preincubationStatus : '0',
    };
    // Call the ListApi function to fetch the list of incubators from the API.
    this.ListApi();
  }
  req;
  excelval;
  /**
   * Fetches the list of incubators and populates the table with the data.
   * Subscribes to the API response and updates the component data.
   * @returns An observable containing the response from the API
   */
  ListApi() {
    this.getdata.amizhthLoader('show');
    this.disList = [];
    return this.makeapi
      .method(this.listApi, this.list, 'post')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        // If there is no data, set the noData flag to true
        if (data.totalIncubators == 0) {
          this.noData = true;
        } else {
          // If there is data, set the noData flag to false and update the component data
          this.noData = false;
          // Set the total count of incubators
          this.pageTotalCount = data.totalIncubators;
          // Set the list of incubators to be displayed
          this.disList = data.incubators;
          // Set the MatTableDataSource with the list of incubators
          this.dataSource = new MatTableDataSource(data.incubators);
        }
      });
  }
  sam;
  /**
   * Saves the incubator name and id to the session storage and navigates to the pre-incubation dashboard.
   * @param id - The id of the incubator.
   * @param name - The name of the incubator.
   */
  incubaName(id, name) {
    // Save the incubator id and name to the session storage.
    sessionStorage.setItem('userId', id);
    sessionStorage.setItem('adminIncubName', name);
    // Set the admin pre-incubation value to '1' in session storage.
    sessionStorage.setItem('adminPreIncubVal', '1');

    // Retrieve the admin pre-incubation value from session storage.
    this.sam = sessionStorage.getItem('adminPreIncubVal');

    // If the admin pre-incubation value is 1, navigate to the pre-incubation dashboard.
    if (this.sam == '1') {
      this.router.navigateByUrl('/admin/pre-incubation/dashboard');
    }
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  /**
   * Handles the pagination event and updates the list parameters.
   * Resets the paginator and page number if applicable, and fetches the updated list.
   * @param event - The pagination event containing the page index and page size.
   */
  getServerData(event) {
    // Reset the search input value if applicable
    if (this.inputElement && this.inputElement.nativeElement) {
      this.inputElement.nativeElement.value = '';
    }
    // Update the page number and page size
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    // Create the request parameters for the API call
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      status: this.selectedOption,
    };
    // Call the API to fetch the updated list
    this.ListApi();
  }
  selectedOption = '0';
  /**
   * Handles the selection change event for the status option.
   * Updates the search value, resets input fields, and updates the session storage.
   * Resets pagination and triggers the list API to fetch data based on the selected status.
   * @param option The selected status option.
   */
  onSelect(option) {
    // Clear the search value
    this.searchVal = '';
    // Reset the input element's value if it exists
    if (this.inputElement && this.inputElement.nativeElement) {
      this.inputElement.nativeElement.value = '';
    }
    // Update the selected option and store it in session storage
    this.selectedOption = option;
    sessionStorage.setItem('preIncubationStatus', this.selectedOption);
    // Reset pagination
    this.pageNumber = 1;
    // Update the list object with the new status and pagination details
    this.list = {
      listSize: this.pageSize,
      pageNumber: this.pageNumber,
      status: option,
    };
    // Call the API to fetch the updated list based on the selected status
    this.ListApi();
    // Reset the paginator
    this.paginator.pageIndex = 0;
  }
  /**
   * Opens a dialog to view the description details.
   * @param status - The status associated with the description.
   * @param title - The title of the description.
   */
  viewDescrptionBtn(status, title) {
    // Create a dialog reference for the RemarksComponent dialog
    const dialogRef = this.dialog.open(RemarksComponent, {
      width: '390px',
      data: { _status: status, _title: title },
    });

    // Handle the dialog's closed event
    dialogRef.afterClosed().subscribe((result) => {
      // No action needed after the dialog is closed
    });
  }
  /**
   * Opens a modal dialog box for sending an email to the selected application.
   * The modal dialog box takes the list of applications as input.
   */
  openModal() {
    if (this.searchValue == undefined) {
      // If the search value is undefined, set it to an empty string
      this.searchValue = '';
    }
    let name;
    // Set the name of the status based on the selected option
    switch (this.selectedOption) {
      case '0':
        this.excelval = 0;
        name = 'Pending';
        break;
      case '1':
        this.excelval = 1;
        name = 'Submitted';
        break;
      case '2':
        this.excelval = 2;
        name = 'Under Process Verficiation';
        break;
      case '3':
        this.excelval = 3;
        name = 'Under Clarification';
        break;
      case '4':
        this.excelval = 4;
        name = 'Approved';
        break;
      case '5':
        this.excelval = 5;
        name = 'Rejected';
        break;
    }
    // Open the modal dialog box
    const dialogRef = this.dialog.open(EmailModalComponent, {
      width: '700px',
      height: '280px',
      data: { _key: this.list },
    });
    // Subscribe to the afterClosed event and do nothing with the result
    dialogRef.afterClosed().subscribe((result) => {});
  }
}
